<tds-side-menu aria-label="Side menu" id="side-menu" persistent open="true" open="{{ isMenuOpened }}">
  <tds-side-menu-overlay
    slot="overlay"
    (click)="mobileMenuAction(false)"
  ></tds-side-menu-overlay>
  <tds-side-menu-close-button
    slot="close-button"
    aria-label="Close drawer menu"
    (click)="mobileMenuAction(false)"
  ></tds-side-menu-close-button>

  @if (isMobile) {
    <tds-side-menu-dropdown>
      <tds-icon slot="icon" name="profile" size="24px"></tds-icon>
      @if (isMobile) {
        <tds-side-menu-user
          slot="label"
          heading="{{ userName }}"
          subheading="{{ userEmail }}"
        ></tds-side-menu-user>
      }
      <tds-header-dropdown-list-item>
        <a (click)="logout()">
          <tds-icon name="exit"></tds-icon>
          <div class="tds-u-pl1">Logout</div>
        </a>
      </tds-header-dropdown-list-item>
    </tds-side-menu-dropdown>
  }

  @if (isMobile) {
    <tds-side-menu-dropdown label="Markets">
      <span slot="label">{{ selectedMarketLabel }}</span>
      @for (market of userMarkets; track market) {
        <tds-side-menu-item>
          <button (click)="onChangeMarket(market.id)">
            {{ market.name }}
          </button>
        </tds-side-menu-item>
      }
    </tds-side-menu-dropdown>
  }

  @for (item of menuItems; track item) {
    @if (!item.subMenu && canAccess(item)) {
      <tds-side-menu-item
        [selected]="(selectedMenu$ | async) === item.label">
        <button (click)="navigate(item.label, item.path)">
          <tds-icon [name]="item.icon" size="24px"></tds-icon>
          {{ item.label }}
        </button>
      </tds-side-menu-item>
    }
    @if (item?.subMenu?.length && canAccess(item)) {
      <tds-side-menu-dropdown
        [label]="item.label"
        >
        <tds-icon
          slot="icon"
          [name]="item.icon"
          size="24"
        ></tds-icon>
        <span slot="label">{{ item.label }}</span>
        @for (sub of item.subMenu; track sub) {
          <tds-side-menu-item (click)="navigate(sub.label, sub.path)">
            <button>
              <tds-icon [name]="sub.icon" size="24px"></tds-icon>
              {{ sub.label }}
            </button>
          </tds-side-menu-item>
        }
      </tds-side-menu-dropdown>
    }
  }

  <tds-side-menu-collapse-button slot="sticky-end">
    Collapse
  </tds-side-menu-collapse-button>
</tds-side-menu>